import styled from 'styled-components';
import { BREAKPOINTS, colors } from '@manulife/mux';

export const Wrapper = styled.div`
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const MainContainer = styled.div`
  display: flex;
  width: 100%;

  justify-content: space-between;

  flex-direction: column;
  @media (min-width: ${BREAKPOINTS.TABLET_LANDSCAPE}px) {
    flex-direction: row;
  }
`;

export const SignInWrapper = styled.div`
  flex: ${({ showRedesignedView }) => (showRedesignedView ? '0 0 100%' : '0 0 409px')};
`;

export const SignInProductInfoWrapper = styled.div`
  flex: 1 1 auto;

  @media (min-width: ${BREAKPOINTS.TABLET_LANDSCAPE}px) {
    margin-left: 8rem;
  }
`;

export const MessageWrapper = styled.div`
  text-align: start;

  & button {
    align-items: start;
  }
`;

export const IntroductionPageCardWrapper = styled.div`
  max-width: 720px;
  margin-top: 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 350px), 1fr));
  gap: 20px;
`;

export const TooltipWrapper = styled.span`
  margin-left: 5px;
`;

export const SignInMessageWrapper = styled.div`
  text-align: start;

  & button,
  a {
    align-items: center;
  }

  &.custom-link-wrapper {
    a {
      padding: ${(props) => {
        let paddingValue;
        if (props.isTooltip) {
          paddingValue = '0px 2px 0px 0px';
        } else if (props.showRedesignedView) {
          paddingValue = '0px 12px 0px 0px';
        } else {
          paddingValue = '12px 12px 12px 0px';
        }
        return paddingValue;
      }};
      display: inline-flex;
      color: ${colors.dark_navy} !important;
      font-weight: 400 !important;
      text-decoration: none;
      align-items: center;
      & div {
        display: inline-flex;
        align-items: center;
      }
      & svg {
        margin: 0px !important;
        height: 1.3125rem !important;
      }
    }
  }
  &.wrapper-with-tooltip {
    display: flex;
    align-items: center;
    span {
      svg {
        height: 18px;
        width: 18px;
      }
    }
  }
`;

export const ListWrapper = styled.div`
  padding-left: 1rem;
`;
